<script setup lang="ts">
  import { useInitPage } from '@/composables/useInitPage'

  const pageStory = await useInitPage('manage-my-booking')

  definePageMeta({
    pageType: 'mmb',
    layout: 'index-page'
  })

  useMetaTags(pageStory)
</script>

<template>
  <StoryblokComponent
    v-if="pageStory?.content"
    :blok="pageStory?.content"
  />
</template>
